export var AI_WEB_MODULE_CONFIG = 'AI_WEB_MODULE_CONFIG';